import { render, staticRenderFns } from "./EditableProp.vue?vue&type=template&id=1ff5cf6c&scoped=true&"
import script from "./EditableProp.vue?vue&type=script&lang=js&"
export * from "./EditableProp.vue?vue&type=script&lang=js&"
import style0 from "./EditableProp.vue?vue&type=style&index=0&id=1ff5cf6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff5cf6c",
  null
  
)

export default component.exports